import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { environment } from '../../environments/environment.prod';
import { ErrorShowService } from './error-show.service';
import { TokenService } from './token.service';

const baseUrl = environment.baseUrl;
@Injectable({
  providedIn: 'root',
})
export class SharedALLService {
  USER_ID: String;
  SUBPROJECT_ID: string = this.tokenService.getSubprojectID();
  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService, private errorShowService: ErrorShowService
  ) {
    let USER = this.tokenService.getUserData();
    if (USER)
    this.USER_ID = USER['USERID'];
  }

  frenchiseService() {
    let userId = this.tokenService.getUserId();
    const body = new HttpParams()
      .set('userid', userId)

    return this.httpClient.post(
      `${baseUrl}select_franchise_v2.php`, body.toString()
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          this.tokenService.authCodeExpired();
        }
        return throwError(() => error);
      }));
  }

  SetfrenchiseService(data) {
    let userId = this.tokenService.getUserId();
    const body = new HttpParams()
      .set('userid', userId)
      .set('subprojectid', data)
    return this.httpClient.post(
      `${baseUrl}select_franchise_v2.php`, body.toString()
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          this.tokenService.authCodeExpired();
        }
        return throwError(() => error);
      }));
  }


  callAPI(type: string, apiNameUrl: string, dataToSend: any, document?: any) {
    //Need to Work on api calling structure :: TODO
    let USER = this.tokenService.getUserData();
    if (USER)
      this.USER_ID = USER['USERID'];
    let url = '';
    switch (type) {
      case 'POST': {
        url = baseUrl + apiNameUrl;

        try {
          return this.httpClient.post(url, dataToSend).pipe(
            catchError((error: HttpErrorResponse) => {
              if (error.status == 401) {
                this.tokenService.authCodeExpired();
              }
              else if (error.status == 500) {
                this.errorShowService.showError("Internal server error");
              }
              return throwError(() => error);
          }));
        } catch (ex) {
          console.log(ex)
          return null;
        }
      }
      case 'GET': {
        if (apiNameUrl == 'all_bis.php') {
          url = baseUrl + 'all_bis.php?subprojectid=' + this.tokenService.getSubprojectID() + '&userid=' + this.USER_ID;
        } else if (apiNameUrl == 'product_filter.php') {
          url = baseUrl + 'product_filter.php?subprojectid=' + this.tokenService.getSubprojectID() + '&userid=' + this.USER_ID + '&doctypeid=' + dataToSend.doctypeid;
        }
        else if (apiNameUrl == 'chart_filter.php') {
          url = baseUrl + 'chart_filter.php?subprojectid=' + this.tokenService.getSubprojectID() + '&userid=' + this.USER_ID;
        }
        else if (apiNameUrl == 'zone.php') {
          url = baseUrl + 'zone.php';
        }
        else if (apiNameUrl == 'delete_pic.php') {
          url = baseUrl + 'delete_pic.php?path=' + dataToSend.item.file.name + '&documentid=' + document.DOCUMENTID;
        }
        else if (apiNameUrl == 'workshop_list.php') {
          url = baseUrl + 'workshop_list.php?userid=' + this.tokenService.getUserId() + '&subprojectid=' + this.tokenService.getSubprojectID();
        }
        else if (apiNameUrl == 'view_user_bookmarks.php') {
          url = baseUrl + 'view_user_bookmarks.php?congressid=' + dataToSend + '&userid=' + this.tokenService.getUserId();
        }
        else if (apiNameUrl == 'dm_history.php') {
          url = baseUrl + 'dm_history.php?userid=' + this.tokenService.getUserId() + '&subprojectid=' + this.tokenService.getSubprojectID();
        }
        else if (apiNameUrl == 'Add_user_drop.php') {
          url = baseUrl + 'Add_user_drop.php?userid=' + this.tokenService.getUserId();
        }
        else if (apiNameUrl == 'stats.php') {
          url = baseUrl + 'stats.php?userid=' + this.tokenService.getUserId() + '&subprojectid=' + this.tokenService.getSubprojectID() + '&doctypeid=' + dataToSend['doctypeid'];
        }
        else if (apiNameUrl == 'get_instructions.php') {
          url = baseUrl + 'get_instructions.php?userid=' + this.tokenService.getUserId() ;
        }
        else {
          url = apiNameUrl
        }
        try {
          return this.httpClient.get(url).pipe(
            catchError((error: HttpErrorResponse) => {
              if (error.status == 401) {
                this.tokenService.authCodeExpired();
              }
              return throwError(() => error);
            }));
        } catch (ex) {
          return null;
        }
      }
      case 'DELETE':
        //consoledataToSend.item.file.name);
        //consoledocument.DOCUMENTID);
        if (apiNameUrl == 'delete_pic.php') {
          url =
            baseUrl +
            'delete_pic.php?path=' +
            dataToSend.item.file.name +
            '&documentid=' +
            document.DOCUMENTID;
        }
        try {
          return this.httpClient.get(url).pipe(
            catchError((error: HttpErrorResponse) => {
              if (error.status == 401) {
                this.tokenService.authCodeExpired();
              }
              return throwError(() => error);
            }));
        } catch (ex) {
          //console'API Service catch');
          //consoleex);
          return null;
        }
      default: {
        //console'Invalid choice');
        return null;
      }
    }
  }
}
